import { FieldType } from "@/enums";

export const getFileListToUpload = (file, fileList, fieldType) => {
  const fileAlreadyExists = fileList?.find(({ uid }) => uid === file.uid);

  if (fileAlreadyExists) return;

  if (fieldType === FieldType.MultiAttachment) {
    return [...fileList, file];
  }

  return [file];
};
